'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _angularFix = require('angular-fix');

var _angularFix2 = _interopRequireDefault(_angularFix);

exports['default'] = addCustomTags;

// @ngInject
function addCustomTags($document) {
  if ($document && $document.get) {
    (function () {
      // IE8 check ->
      // http://stackoverflow.com/questions/10964966/detect-ie-version-prior-to-v9-in-javascript/10965203#10965203
      var document = $document.get(0);
      var div = document.createElement('div');
      div.innerHTML = '<!--[if lt IE 9]><i></i><![endif]-->';
      var isIeLessThan9 = div.getElementsByTagName('i').length === 1;

      if (isIeLessThan9) {
        // add the custom elements that we need for formly
        var customElements = ['formly-field', 'formly-form', 'formly-custom-validation', 'formly-focus', 'formly-transpose'];
        _angularFix2['default'].forEach(customElements, function (el) {
          document.createElement(el);
        });
      }
    })();
  }
}
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./run/formlyCustomTags.js
 **/